/**
 * Google Analytics 4 integration for 86 Proof public site.
 *
 * Three gates determine whether GA loads:
 *   1. VUE_APP_GA_MEASUREMENT_ID env var is set (build-time kill switch).
 *   2. Hostname is a known production hostname (86proof.ai).
 *   3. The visitor has not set Do Not Track.
 *
 * If all three pass, gtag.js is dynamically injected and pageviews are
 * fired manually on every Vue Router navigation. Auto-pageview is
 * disabled (send_page_view: false) so initial-load and route-change
 * events come from one source.
 */

const PROD_HOSTNAMES = new Set(['86proof.ai'])

function isDoNotTrackSet() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false
  const nav = navigator
  const win = window
  return (
    nav.doNotTrack === '1'
    || nav.doNotTrack === 'yes'
    || win.doNotTrack === '1'
    || nav.msDoNotTrack === '1'
  )
}

function shouldLoadAnalytics() {
  const id = process.env.VUE_APP_GA_MEASUREMENT_ID
  if (!id) return false
  if (typeof window === 'undefined') return false
  if (!PROD_HOSTNAMES.has(window.location.hostname)) return false
  if (isDoNotTrackSet()) return false
  return true
}

function loadGtag(id) {
  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() {
    window.dataLayer.push(arguments)
  }
  window.gtag('js', new Date())
  window.gtag('config', id, {
    // Pageviews fired manually via router.afterEach; disabling auto-send
    // prevents duplicate events on initial load.
    send_page_view: false,
  })
}

let initialized = false

export function initAnalytics(router) {
  if (initialized) return
  if (!shouldLoadAnalytics()) return
  initialized = true

  const id = process.env.VUE_APP_GA_MEASUREMENT_ID
  loadGtag(id)

  router.afterEach((to) => {
    if (typeof window.gtag !== 'function') return
    window.gtag('event', 'page_view', {
      page_path: to.fullPath,
      page_title: document.title,
      page_location: window.location.href,
    })
  })
}
